import { camelCase } from 'lodash';

/**
 * Builds a Record mapping each enum value to its camelCased key,
 * useful for deriving translation keys from enum definitions.
 */
export function enumToCamelCaseMap<T extends Record<string, string>>(
    enumObj: T
): Record<T[keyof T], string> {
    return (Object.keys(enumObj) as (keyof T)[]).reduce(
        (acc, key) => ({
            ...acc,
            [enumObj[key]]: camelCase(key as string),
        }),
        {} as Record<T[keyof T], string>
    );
}

export function getEnumKeyByValue<T extends { [index: string]: string }>(
    enumerated: T,
    value: string
) {
    return Object.keys(enumerated)[Object.values(enumerated).indexOf(value)];
}
